import styles from './hash-used.module.css';

export const HashUsedPage = () => {
  return (
    <div className={styles.container}>
      <img className={styles.logo} src="logo.svg" alt="playwall logo" />

      <span className={styles.text}>
        QR Code has been already used <br /> Please scan a new code
      </span>
      <div />
    </div>
  );
};
